var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPinIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 7.99991C16.0002 11.9943 11.569 16.1543 10.081 17.4391C9.94237 17.5433 9.77363 17.5997 9.6002 17.5997C9.42676 17.5997 9.25802 17.5433 9.1194 17.4391C7.6314 16.1543 3.2002 11.9943 3.2002 7.99991C3.2002 6.30253 3.87448 4.67466 5.07471 3.47443C6.27494 2.2742 7.90281 1.59991 9.6002 1.59991C11.2976 1.59991 12.9254 2.2742 14.1257 3.47443C15.3259 4.67466 16.0002 6.30253 16.0002 7.99991Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6002 10.3999C10.9257 10.3999 12.0002 9.3254 12.0002 7.99991C12.0002 6.67443 10.9257 5.59991 9.6002 5.59991C8.27471 5.59991 7.2002 6.67443 7.2002 7.99991C7.2002 9.3254 8.27471 10.3999 9.6002 10.3999Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinIconWhite);
export default __webpack_public_path__ + "static/media/map-pinIconWhite.00871f8a1ad96b830c85e53a8022b9d6.svg";
export { ForwardRef as ReactComponent };